import type { ProcurementTypeFilter } from './esPortfolioFilters'

const selectClass =
  'rounded-[var(--radius-sm)] border border-es-hairline px-2.5 py-2 text-sm bg-es-white text-es-body focus:border-es-signal focus:outline-none focus:ring-1 focus:ring-es-signal'

type ProcurementTypeSelectProps = {
  value: ProcurementTypeFilter
  onChange: (next: ProcurementTypeFilter) => void
  className?: string
  /** When true, show a short “Portfolio” label beside the select. */
  showLabel?: boolean
  id?: string
}

/** Direct / Indirect / Both — shared portfolio scope control for ES views. */
export function ProcurementTypeSelect({
  value,
  onChange,
  className = '',
  showLabel = true,
  id = 'es-procurement-type',
}: ProcurementTypeSelectProps) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`.trim()}>
      {showLabel ? (
        <label
          className="text-xs font-semibold uppercase tracking-wider text-es-muted"
          htmlFor={id}
        >
          Portfolio
        </label>
      ) : null}
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value as ProcurementTypeFilter)}
        className={selectClass}
        aria-label="Direct or Indirect"
      >
        <option value="direct">Direct</option>
        <option value="indirect">Indirect</option>
        <option value="all">All</option>
      </select>
    </div>
  )
}
